// How a bottle's payment state reads in the dashboard (BOT-1680).
//
// An order placed on an invoice-only store is an order from the moment it is
// placed: its bottle is `invoiced` until Stripe reports the invoice paid, and
// its placement payment (reason `stripe_invoice`) carries a zero charge in the
// meantime. These helpers keep every list, row and detail page on that rule.

const PLACED_STATUSES = ['paid', 'invoiced']

const REASON_LABELS = {
  mark_as_paid: 'Marked as paid',
  less_than_50c: 'Total less than 50 cents'
}

// Serializers expose `payment_status` (the column) and `status` (calculated);
// for a placed order they agree, and lite list rows may only carry `status`.
const placementStatus = attributes => attributes?.payment_status ?? attributes?.status

export const isPlacedOrder = attributes => PLACED_STATUSES.includes(placementStatus(attributes))

export const isInvoicePayment = payment => payment?.attributes?.reason === 'stripe_invoice'

export const awaitingInvoicePayment = (attributes, payment) =>
  isInvoicePayment(payment) && placementStatus(attributes) === 'invoiced'

// BOT-1764: the merchant marked the invoice paid outside Stripe (check, cash,
// bank transfer); no card money moved, so it reads as marked paid, not charged.
export const collectedOutsideStripe = payment =>
  isInvoicePayment(payment) && payment.attributes.collected_outside_stripe === true

export const paymentReasonLabel = (attributes, payment) => {
  if (isInvoicePayment(payment)) {
    if (awaitingInvoicePayment(attributes, payment)) return 'Invoiced'
    return collectedOutsideStripe(payment) ? 'Marked as paid' : 'Invoice paid'
  }
  return REASON_LABELS[payment?.attributes?.reason]
}
